import { Injectable } from '@angular/core';
import { ApiService } from '../../../shared/index';
import { NahbMemberType } from './nahb-member-type.model';
import { NahbBusinessActivity } from './nahb-business-activity.model';
import { NahbCodeDto } from './dto/nahb-code.dto';
import { HbaProfileReadDto } from './dto/hba-profile.read.dto';
import { HbaNahbBatchDto } from './dto/hba-nahb-batch.dto';
import { HbaNahbExportDto } from './dto/hba-nahb-export.dto';
import { HbaNahbExportResultDto } from './dto/hba-nahb-export-result.dto';

@Injectable({
  providedIn: 'root',
})
export class VerticalNahbService {
  public constructor(private _apiService: ApiService) {}

  public getProfileHbaData(profileId: number): Promise<HbaProfileReadDto> {
    return this._apiService.get(`Vertical/Hba/${profileId}`);
  }

  public upsertProfileHbaData(dto: HbaProfileReadDto): Promise<void> {
    return this._apiService.post(`Vertical/Hba/${dto.ProfileId}`, dto);
  }

  public getHbaMemberTypes(): Promise<Array<NahbMemberType>> {
    return this._apiService.get('Vertical/Hba/MembershipTypes').then((data: Array<NahbMemberType>) => {
      return Promise.resolve(this.removeEmptyItem(data));
    });
  }

  public getHbaBusinessActivityTypes(): Promise<Array<NahbBusinessActivity>> {
    return this._apiService.get('Vertical/Hba/BusinessActivities').then((data) => {
      return Promise.resolve(this.removeEmptyItem(data));
    });
  }

  public getHbaMembershipStatuses(): Promise<NahbCodeDto[]> {
    return this._apiService.get('Vertical/Hba/MembershipStatuses').then((data) => {
      return Promise.resolve(this.removeEmptyItem(data));
    });
  }

  public getHbaNumberOfUnits(): Promise<NahbCodeDto[]> {
    return this._apiService.get('Vertical/Hba/NumberOfUnits').then((data) => {
      return Promise.resolve(this.removeEmptyItem(data));
    });
  }

  public getHbaDollarVolumes(): Promise<NahbCodeDto[]> {
    return this._apiService.get('Vertical/Hba/DollarVolumes').then((data) => {
      return Promise.resolve(this.removeEmptyItem(data));
    });
  }

  public getHbaContactTitleTypes(): Promise<NahbCodeDto[]> {
    return this._apiService.get('Vertical/Hba/Titles').then((data) => {
      return Promise.resolve(this.removeEmptyItem(data));
    });
  }

  public getHbaLastNahbBatch(): Promise<HbaNahbBatchDto> {
    return this._apiService.get('Vertical/Hba/Nahb/LastBatch');
  }

  public getExportedNahbChangesByBatchId(batchId: number): Promise<HbaNahbExportDto[]> {
    return this._apiService.get(`Vertical/Hba/Nahb/Changes/History/Batch/${batchId}`);
  }

  public exportNahbProfileChanges(): Promise<string> {
    return this._apiService.get(`Vertical/Hba/Nahb/Changes/Export`);
  }

  public getNahbChanges(): Promise<HbaNahbExportResultDto> {
    return this._apiService.get(`Vertical/Hba/Nahb/Changes/No-Invoices`);
  }

  public exportNahbValidation(): Promise<string> {
    return this._apiService.get(`Vertical/Hba/Nahb/Changes/validation/export`);
  }

  private removeEmptyItem(data: any[]): any {
    const eI = data?.findIndex((x) => x.Descr === '');
    if (eI > -1) {
      data.splice(eI, 1);
    }

    return data;
  }
}
